import styled, {css} from 'styled-components'

export const StyledMenuItemText = styled.span`
    ${({theme: {palette}}) => css`
        color: ${palette.danger['600']};
    `}
`
